// extracted by mini-css-extract-plugin
export default {"rating":"Vx-z","numberOfStars":"Wx-z","count":"Xx-z","barGraphSpacing":"Yx-z","barGraph":"Zx-z"};